module.exports = __webpack_public_path__ + "static/img/jianzhu10.a9b82b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu10.png
// module id = 1DLx
// module chunks = 12